module.exports = __webpack_public_path__ + "img/DoctorsFolder.0a0cc38e.svg";